import React from "react";
import Select2 from "../Select2.js";
import PropTypes from "prop-types";
import styles from "./CommonSelect.module.css";
import "./CommonSelect.css";

/**
 * Input reutilizável para seleção de opções
 */
function CommonSelect({
  label,
  id,
  value,
  onChange,
  data,
  placeholder = "Selecione",
  required = false,
  disabled = false,
  labelStyle = {},
  sent = false,
  ...props
}) {
  return (
    <>
      {label && (
        <>
          <label htmlFor={id} className={styles.label} style={labelStyle}>
            {label}
          </label>
          {required && <span style={{ color: "#f46a6a" }}> *</span>}
        </>
      )}
      <div className={`${sent && !value ? "error" : ""}`}>
        <Select2
          name={id}
          id={id}
          className={`${styles.input}`}
          style={{ width: "100%" }}
          value={value}
          onChange={disabled ? null : onChange}
          data={data}
          disabled={disabled}
          options={{
            placeholder,
          }}
          {...props}
        />
      </div>
    </>
  );
}

CommonSelect.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  labelStyle: PropTypes.string,
  sent: PropTypes.bool,
};

export default CommonSelect;
